<script>
export default {
  props: {
    header: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    imagePath: {
      type: String,
      required: true
    },
    inverted: {
      type: Boolean,
      required: false,
      default: false
    },
    gradient: {
      type: Boolean,
      required: false,
      default: false
    },
    onClick: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div class="root" :class="{gradient: gradient}" @click="$emit('onClick')">
    <div class="outside-header">
      {{ header }}
    </div>

    <div class="card-content" :class="{ 'card-content-inverted': inverted }">
      <div class="text-content" :class="{ 'text-content-inverted': inverted }">
        <div class="inside-header">
          {{ header }}
        </div>

        <span class="text">
          {{ text }}
        </span>
      </div>

      <img :src="imagePath" />
    </div>

  </div>
</template>

<style scoped>
.root {
  width: calc(100% - 40px);
  padding: 24px 20px;
  border-radius: 2px;
  background-color: #603285;
  display: flex;
  flex-direction: column;
}

.gradient {
  background: linear-gradient(90deg, var(--purple) 0%, var(--pink) 100%);
}

.outside-header,
.inside-header {
  font-size: 24px;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 16px;
  color: #e2e2e2;
}

.inside-header {
  display: none;
}

.card-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-content-inverted {
  flex-direction: row-reverse;
}

.text-content {
  width: calc(100% - 80px - 12px);
}

.text-content-inverted {
  text-align: end;
}

.text {
  font-size: 14px;
  color: #e2e2e2;
}

img {
  width: 80px;
}

@media (min-width: 425px) {
  .outside-header {
    display: none;
  }

  .inside-header {
    display: inherit;
  }

  .text-content {
    width: calc(100% - 100px - 12px);
  }

  img {
    width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/components/InfoCards/cards/Card.vue